export default "__VITE_ASSET__Vz07fECh__";